<template>
  <b-container class="mt-5">
    <b-row>
      <b-col sm="12">
        <b-card header-tag="header" footer-tag="footer">
          <b-row>
            <b-col sm="7">
              <h4 id="traffic" class="card-title mb-0">Ajuste del Software</h4>
              <div class="small text-muted">Administre las características visuales del software</div>
            </b-col>
          </b-row>
        </b-card>

        <div>
          <b-card no-body>
            <b-tabs pills card>
              <b-tab title="Título" active>
                <b-card-text>
                  <b-row>
                    <b-col>
                      <b-form-group label="Proyecto" class="settings-proyecto-label-custom" description="Ingrese el nombre de la empresa que va a utilzar el software">
                        <b-form-input v-model="form.proyectName" type="text" required placeholder="Nombre de Proyecto"></b-form-input>
                      </b-form-group>
                    </b-col>
                  </b-row>
                </b-card-text>
              </b-tab>
              <b-tab title="Imágenes">
                <b-card-text>
                  <b-row>
                    <b-col>
                      <b-form-group label="Logo" class="settings-imagen-label-custom" description="Medidas en relación a 150x50">                       
                        <Imagen :images="form.logo" @load-image="form.logo = $event" typeImage="Logo"/>
                        <BrandingRestoreControl
                          target="logo"
                          :customized="branding.logo_customized"
                          @restored="brandingRestored"
                        />
                      </b-form-group>
                    </b-col>

                    <b-col>
                      <b-form-group label="Favicon" class="settings-imagen-label-custom" description="Medidas en relación a 50x50">
                        <Imagen :images="form.favicon" @load-image="form.favicon = $event" typeImage="Favicon"/>
                        <BrandingRestoreControl
                          target="favicon"
                          :customized="branding.icon_customized"
                          @restored="brandingRestored"
                        />
                      </b-form-group>
                    </b-col>

                  </b-row>
                  <b-row>
                    <b-col>
                      <b-form-group
                        label="Contraste del logo"
                        class="settings-imagen-label-custom"
                        description="Seleccione el fondo que se usará detrás del logo de la empresa en login, perfil y espacios destacados"
                      >
                        <b-form-radio-group
                          v-model="form.logoContrast"
                          :options="logoContrastOptions"
                          buttons
                          button-variant="outline-secondary"
                          size="sm"
                          class="settings-logo-contrast-control"
                        />

                        <div class="settings-logo-contrast-preview">
                          <button
                            v-for="option in logoContrastOptions"
                            :key="option.value"
                            type="button"
                            class="settings-logo-contrast-preview__item"
                            :class="{ 'settings-logo-contrast-preview__item--active': form.logoContrast === option.value }"
                            @click="form.logoContrast = option.value"
                          >
                            <span class="settings-logo-contrast-preview__label">{{ option.text }}</span>
                            <CustomerBrandLogo
                              variant="full"
                              context="dropdown"
                              :surface="option.value"
                              :source-override="logoPreviewSource"
                              :alt="form.proyectName || 'Empresa'"
                            />
                          </button>
                        </div>
                      </b-form-group>
                    </b-col>
                  </b-row>
                </b-card-text>
              </b-tab>
            </b-tabs>
          </b-card>
        </div>

        <b-card header-tag="header" footer-tag="footer">
          <b-row>
            <b-col>
              <b-button variant="dark" class="pull-right" @click="guardar()">Guardar</b-button>
            </b-col>
          </b-row>
        </b-card>
      </b-col>
    </b-row>
  </b-container>
</template>

<script>
  import Error from '@/handler/error'
  import Session from '@/handler/session'  
  import serviceAPI from './services'
  import Imagen from '@/components/inc/image/image'
  import BrandingRestoreControl from './BrandingRestoreControl'
  import CustomerBrandLogo from '@/components/branding/CustomerBrandLogo'

  export default {
    components: {
      Imagen,
      BrandingRestoreControl,
      CustomerBrandLogo,
    },
    data () {
      return {
        form: {
          logo: [],
          favicon: [],
          imageLogin: [],
          logoContrast: 'auto',
          proyectName: '',
        },
        logoContrastOptions: [
          { text: 'Automático', value: 'auto' },
          { text: 'Fondo claro', value: 'light' },
          { text: 'Fondo oscuro', value: 'dark' },
        ],
        branding: {
          logo_customized: false,
          icon_customized: false,
          login_customized: false,
        },
      }
    },
    mounted() {
      this.cargar()
    },
    methods: {
      cargar () {
        var result = serviceAPI.obtener()

        result.then((response) => {
          var data = response.data
          var settings = {}

          data.settings.forEach((value) => {
            settings[value.reference] = value.value
          })

          if(settings.logo) {
            this.form.logo = [{ path: settings.logo }]
          }

          if(settings.favicon) {
            this.form.favicon = [{ path: settings.favicon }]
          }

          if(settings.image_login) {
            this.form.imageLogin = [{ path: settings.image_login }]
          }

          this.form.proyectName = settings.proyect_name
          this.form.logoContrast = ['auto', 'light', 'dark'].indexOf(settings.logo_contrast) !== -1
            ? settings.logo_contrast
            : 'auto'
          this.branding = data.branding || this.branding
        })
      },
      brandingRestored(payload) {
        const settings = {}
        payload.data.settings.forEach(value => {
          settings[value.reference] = value.value
        })

        const formField = payload.target === 'image_login'
          ? 'imageLogin'
          : payload.target

        this.form[formField] = settings[payload.target]
          ? [{ path: settings[payload.target] }]
          : []
        this.branding = payload.data.branding || this.branding
      },
      guardar () {
        let loader = this.$loading.show()

        var logo = new FormData();
        this.form.logo.forEach((value, key) => {
          logo.append(key, value.path);
        })

        var favicon = new FormData();
        this.form.favicon.forEach((value, key) => {
          favicon.append(key, value.path);
        })

        var imageLogin = new FormData();
        this.form.imageLogin.forEach((value, key) => {
          imageLogin.append(key, value.path);
        })

        var result = serviceAPI.guardar(JSON.stringify(this.form), logo, favicon, imageLogin)

        result.then((response) => {
          var data = response.data
          if (data.status) {
            Session.setSessionSettings(data)
            this.$awn.success("Configuración Guardada")
            this.$router.push({ name: 'Init' })
          } else {
            this.$awn.info("Faltan cargar algunos campos")
          }

          loader.hide()
        })
        .catch(error => {
          this.$awn.alert(Error.showError(error))
          loader.hide()
        });
      },
    },
    computed: {
      logoPreviewSource() {
        return this.form.logo.length && this.form.logo[0].path
          ? this.form.logo[0].path
          : ''
      },
    },
  }
</script>
<style>
  .settings-proyecto-label-custom legend {
    text-align: left !important;
  }
  .settings-imagen-label-custom legend {
    text-align: left !important;
  }
  legend {
    font-weight: 600;
  }
  .settings-logo-contrast-control {
    display: flex;
    flex-wrap: wrap;
    gap: 0.35rem;
    margin-bottom: 0.85rem;
  }
  .settings-logo-contrast-preview {
    display: flex;
    flex-wrap: wrap;
    gap: 0.75rem;
  }
  .settings-logo-contrast-preview__item {
    display: inline-flex;
    flex-direction: column;
    align-items: center;
    gap: 0.5rem;
    min-width: 138px;
    padding: 0.75rem;
    border: 1px solid #d8dbe0;
    border-radius: 8px;
    background: #fff;
    cursor: pointer;
  }
  .settings-logo-contrast-preview__item--active {
    border-color: #007992;
    box-shadow: 0 0 0 2px rgba(0, 121, 146, 0.14);
  }
  .settings-logo-contrast-preview__label {
    color: #526276;
    font-size: 0.75rem;
    font-weight: 600;
  }
</style>
